import { createFileRoute } from "@tanstack/react-router";
import SafetyStandardsPage from "@/site/pages/safety";

export const Route = createFileRoute("/safety")({
  component: SafetyStandardsPage,
});
